import React from 'react'
import { string, object, number } from 'prop-types'
import styles from './EventTestimonial.module.scss'
import cx from 'classnames'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'
import Container from '@/component/Primitive/Container'
import { SpeakerThumbnail } from '@/component/Primitive/Events'

const EventTestimonial = ({
  headline,
  quote,
  theme,
  speaker,
  quoteeOverride,
  flex
}) => {
  const getDisplayedQuote = () => {
    if (quote) return quote
    if (speaker?.testimonial) return speaker.testimonial
    return ''
  }

  return (
    <div
      className={cx(
        styles.EventTestimonial,
        theme === 'light' && styles.light,
        theme === 'dark' && styles.dark,
        theme === 'primary' && styles.primary,
        theme === 'grey' && styles.grey,
        theme === 'lightgrey' && styles.lightgrey
      )}
    >
      <Container
        center
        size="wide"
        gutter
        className={cx(styles.EventTestimonialInner)}
      >
        <div className={styles.ContentWrapper}>
          <Stack className={styles.Content} gap="small">
            {speaker && !quoteeOverride && (
              <SpeakerThumbnail
                {...speaker}
                className={styles.SpeakerThumbnail}
                classNames={{
                  jobTitle: styles.SpeakerThumbnailJobTitle
                }}
              />
            )}
            {quoteeOverride && (
              <Type
                className={styles.QuoteeOverride}
                weight="bold"
                size={['body2', 'body2']}
              >
                {quoteeOverride}
              </Type>
            )}
            {headline && (
              <Type
                as="h1"
                size={['body2', 'body2']}
                weight="medium"
                className={styles.Headline}
              >
                {headline}
              </Type>
            )}

            {getDisplayedQuote() && (
              <Type size={['body2', 'body2']}>{getDisplayedQuote()}</Type>
            )}

            {speaker && (
              <Type size={['body3', 'body3']}>
                {speaker.name && <strong>{speaker.eventName}</strong>}
                {speaker?.roles?.length && speaker.eventName ? (
                  <>
                    {' - '}
                    {speaker.roles.join(' | ')}
                  </>
                ) : (
                  ''
                )}
              </Type>
            )}
          </Stack>
        </div>
      </Container>
    </div>
  )
}

EventTestimonial.propTypes = {
  speaker: object,
  headline: string,
  quote: string,
  theme: string,
  flex: number,
  quoteeOverride: string
}

export default EventTestimonial
